// extracted by mini-css-extract-plugin
export default {"commonTitle":"CommonTitle_commonTitle__hOext","backBtn":"CommonTitle_backBtn__NukfG","modalCloseBtn":"CommonTitle_modalCloseBtn__nxBS0","title":"CommonTitle_title__dXJS0"};